import { useStore } from "../../useStore";

export const useStoreIsUpdateQuantity = useStore(false);
